module.exports = __webpack_public_path__ + "img/ReviewE.e356f710.png";